import { useEffect } from 'react';

const Download = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.myservicecirclemobile.meritz';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = 'https://apps.apple.com/us/app/myservicecircle-app/id6745583450'; // replace with actual link
    } else {
      window.location.href = 'https://www.myservicecircle.app'; // your website
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '30%' }}>
      <p>Redirecting you to the right place...</p>
    </div>
  );
};

export default Download;
